export default {
  text: 'black',
  primary: '#eab600',
  secondary: '#7f7f7f',
  background: 'white',
  backgroundSecondary: 'lightgrey',
  light: '#FFF',
  dark: '#202020'
}
